// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fonticon {
  font-size: 17px;
  width: 15px;
}

.sidebar_icon {
  position: absolute;
  top: 36%;
  opacity: 0.1;
  width: 100%;
  text-align: center;
}

.sidebar .sidebar-header {
  width: 245px;
}
.sidebar .sidebar-header .sidebar-toggler {
  cursor: pointer;
  width: 12px;
}

.pointer {
  cursor: pointer;
}

.sidebar-body {
  width: 245px;
}

@media screen and (min-width: 990px) and (max-width: 2560px) {
  .sidebar-toggler {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EAKE,YAAA;AAHF;AADE;EACE,eAAA;EACA,WAAA;AAGJ;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE;IACE,aAAA;EAAF;AACF","sourcesContent":[".fonticon {\n  font-size: 17px;\n  width: 15px;\n}\n\n.sidebar_icon {\n  position: absolute;\n  top: 36%;\n  opacity: 0.1;\n  width: 100%;\n  text-align: center;\n}\n\n.sidebar .sidebar-header {\n  .sidebar-toggler {\n    cursor: pointer;\n    width: 12px;\n  }\n  width: 245px;\n  \n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.sidebar-body{\n  width: 245px;\n}\n\n@media screen and (min-width: 990px) and (max-width: 2560px) {\n  .sidebar-toggler  {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
